<template>
  <div class="d-flex justify-content-end">
    <list-group
      :identity="identity"
      :classes="classes"
      :button-label="buttonValue"
      button-variant="outline-white"
      :button-classes="isEmotionSelected ? 'shadow-uniform' : 'text-secondary shadow-uniform'"
      :show="showEmotionList"
      :values="emotionListValues"
      value-button-classes="emotion-icon"
      :selected="selectedEmotion ? selectedEmotion : null"
      :tooltip="true"
      :delete-enable="true"
      :delete-tooltip="trans('mood-reactions.emotion_button_delete')"
      @openClick="openListGroup"
      @closeClick="deleteEmotion"
      @selectClick="selectIcon"
    />
  </div>
</template>

<script>
import ListGroup from "../molecules/ListGroup";

export default {
  name: "Emotions",
  components: { ListGroup },
  props: {
    identity: Number,
    selectedEmotion: Number,
    buttonText: String,
    emotionList: Array,
    classes: String,
  },
  data() {
    return {
      showEmotionList: false,
      showTooltip: true,
    };
  },
  computed: {
    emotionListValues: function () {
      return this.emotionList
        .filter((e) => e.id !== -1)
        .map((emotion) => {
          return {
            id: emotion.id,
            label: emotion.icon,
            tooltip: emotion.name,
          };
        });
    },
    isEmotionSelected: function () {
      return !this.showEmotionList && this.selectedEmotion;
    },
    buttonValue: function () {
      if (this.isEmotionSelected) {
        if (this.buttonText) return this.buttonText;
        let emotion = this.getEmotion(this.selectedEmotion);
        return `${emotion.icon} ${emotion.name}`;
      } else return this.trans("mood-reactions.emotion_button_v2");
    },
  },
  methods: {
    openListGroup() {
      this.showEmotionList = true;
      this.$emit("buttonClicked");
    },
    selectIcon(iconId) {
      this.showEmotionList = false;
      this.$emit("emotionChange", {
        id: iconId,
        icon: this.getEmotion(iconId).icon,
        text: this.getEmotion(iconId).name,
      });
    },
    deleteEmotion() {
      this.showEmotionList = false;
      if (this.selectedEmotion) this.$emit("emotionChange", { id: null });
    },
    getEmotion(idIcon) {
      if (this.emotionList.length > 0) {
        return this.emotionList.find((e) => e.id === Number(idIcon));
      }
    },
  },
};
</script>

<style scoped lang="scss">
.emotion-list {
  margin-left: 104px;
  @media (max-width: 1024px) {
    margin-left: 72px;
  }
}
</style>
